import React from 'react';
import Navbar from './Navbar/Navbar';
import ApiCollections from '../Sidebar/ApiCollections';
import HistoryPanel from '../History/HistoryPanel';

export default function Layout({ children, history, setHistory, setSelectedRequest }) {
  return (
    <>
      <Navbar />
      <div className="flex h-screen pt-[60px] overflow-hidden">
        <ApiCollections onRequestSelect={setSelectedRequest} />
        <main className="flex-1 overflow-y-auto py-4 bg-white">
          <div className="max-w-5xl mx-3">{children}</div>
        </main>
        <HistoryPanel history={history} setHistory={setHistory} />
      </div>
    </>
  );
}